








import { defineComponent } from '@vue/composition-api';
import FieldsViewControlsDesktop from './FieldsViewControlsDesktop.vue';
import FieldsViewControlsMobile from './FieldsViewControlsMobile.vue';

export default defineComponent({
	components: {
		FieldsViewControlsMobile,
		FieldsViewControlsDesktop,
	},
});
